<template>
   <node-view-wrapper class="ref">
      <div @click="openModal()">
         <node-view-content class="ref-content" />
         <div class="modal" v-if="showModal">
            ref:
            <input
               type="text"
               placeholder="Voer de ref in"
               ref="inputField"
               v-model="refContent"
            />
            <button @click.stop="showModal = false">Sluiten</button>
         </div>
      </div>
   </node-view-wrapper>
</template>

<script>
import { NodeViewWrapper, NodeViewContent, nodeViewProps } from "@tiptap/vue-2";

export default {
   components: {
      NodeViewWrapper,
      NodeViewContent,
   },
   props: nodeViewProps,
   mounted() {
      this.openModal();
   },
   data() {
      return {
         showModal: false,
         refContent: "",
      };
   },
   methods: {
      openModal() {
         console.log("toggle");
         this.showModal = true;
         //  this.$refs.inputField.focus();
         this.$nextTick(() => this.$refs.inputField.focus());
      },
   },
   watch: {
      "node.textContent": {
         handler(newVal) {
            this.node.attrs.type = newVal;
         },
         immediate: true,
      },
      refContent(newVal) {
         this.node.attrs.ref = newVal;
      },
   },
};
</script>

<style lang="scss">
.ref {
   // background-color: #fff;
   // border: 1px solid #ddd;
   // border-radius: 0.5rem;
   // margin: 1rem 0;
   // position: relative;
   // width: 95%;
   // max-width: 1200px;
   display: inline-block;
   position: relative;
}

.ref-content {
   color: blue;
   text-decoration: underline;
   // margin: 2.5rem 1rem 1rem;
   // padding: 0.5rem;
   // border: 2px dashed #0d0d0d20;
   // border-radius: 0.5rem;
}

.modal {
   position: absolute;
   left: 0;
   background-color: #fff;
   padding: 0.5rem;
   box-shadow: var(--box-shadow);
   z-index: 2;
   top: 100%;
   input {
      font-size: 1rem;
      padding: 8px 12px;
   }
   button {
      background-color: var(--primary-color, #008fc1);
      color: #fff;
      border: 0;
      outline: 0;
      margin-left: auto;
      padding: 8px 12px;
      font-size: 1rem;
      border-radius: 4px;
      margin-top: .5rem;
      display: block;
      font-weight: 500;
      cursor: pointer;
   }
}

// .modal {
//    position: fixed;
//    width: 100vw;
//    height: 100vh;
//    left: 0;
//    top: 0;
//    background-color: rgba(0,0,0,.2);
//    box-shadow: var(--box-shadow);
//    z-index: 999;
//    pointer-events: none;
//    .container {
//       position: absolute;
//       inset: 0;
//       width: 400px;
//    }
// }
</style>
